/**
 * Ad group IDs eligible for the salesCtrRanking experiment.
 * Source: Google Ads CSV export "adgroups_name_and_bk_17_campaigns" (excluding Bali ad groups).
 * To update: export the latest CSV from Google Ads, filter out Bali rows, extract the adgroup_bk column.
 */
export const ELIGIBLE_AD_GROUP_IDS: ReadonlySet<string> = new Set([
  '180511857250',
  '181798082822',
  '181798082862',
  '181798083022',
  '182995159342',
  '182995159422',
  '182995159582',
  '183046973737',
  '183727865743',
  '183727865903',
  '183789065177',
  '183789065217',
  '183996135297',
  '184575029493',
  '184575029693',
  '184770469899',
  '184899850742',
  '184899850782',
  '184964034906',
  '184989376214',
  '185068251483',
  '185068251523',
  '185071849666',
  '185071850626',
  '185114522083',
  '185396880632',
  '185568106526',
  '185570558575',
  '185687279740',
  '185721850232',
  '185832434342',
  '185875031737',
  '185951863897',
  '186053872275',
  '186063514056',
  '186273730503',
  '186350478385',
  '186352065752',
  '186352065792',
  '186395337792',
  '186395337832',
  '186395337992',
  '186451614406',
  '186534878866',
  '186633853573',
  '186724949654',
  '186837130953',
  '186837130993',
  '187045971996',
  '187045972036',
  '187064701180',
  '187076825519',
  '187081237140',
  '187138584410',
  '187216294698',
  '187326053957',
  '187326053997',
  '187452528219',
  '187657664814',
  '187830873065',
  '187838152295',
  '188081766209',
  '188168852138',
  '188168852298',
  '188168853098',
  '188239280520',
  '188239280560',
  '188239280600',
  '189360930190',
  '189360930230',
  '189360930390',
  '189360930430',
  '189360930470',
  '189360930630',
  '189360930670',
  '189430275991',
  '189683541307',
  '189694921383',
  '189767453431',
  '190046742884',
  '190284185012',
  '190284185172',
  '190284185252',
  '190284185412',
  '190284185452',
  '190284185492',
  '190284185652',
  '190284185692',
  '190284185732',
  '190284185892',
  '190284185932',
  '190284185972',
  '190284186132',
  '190284186172',
  '190284186212',
  '190284186372',
  '190284186412',
  '190284186452',
  '190284186612',
  '190284186652',
  '190284186692',
  '190284186852',
  '190284186892',
  '190284186932',
  '190284187092',
  '190284187132',
  '190284187172',
  '190284187332',
  '190284187372',
  '190284187412',
  '190284187572',
  '190284187612',
  '190284187652',
  '190284187812',
  '190284187852',
  '190284187892',
  '190284188052',
  '190284188092',
  '190284188132',
  '190284188292',
  '190284188332',
  '190284188372',
  '190284188532',
  '190284188572',
  '190284188612',
  '190284188772',
  '190284188812',
  '190284188852',
  '190284189012',
  '190284189052',
  '190284189092',
  '190284189252',
  '190284189292',
  '190284189332',
  '190284189492',
  '190284189532',
  '190284189572',
  '190284189732',
  '190496772950',
  '190496773110',
  '190496773150',
  '190496773190',
  '190506969560',
  '190614610235',
  '191069010219',
  '191126874640',
  '191126874680',
  '191184674044',
  '191291606384',
  '191291606624',
  '191291606864',
  '191291607024',
  '191291607064',
  '191291607304',
  '191291607344',
  '191291607584',
  '191291607784',
  '191291607824',
  '191291607984',
  '191291608024',
  '191291608224',
  '191291608264',
  '191291608304',
  '191291608464',
  '191291608504',
  '191291608544',
  '191291608704',
  '191291608784',
  '191291608944',
  '191291608984',
  '191291609024',
  '191291609224',
  '191291609264',
  '191291609424',
  '191291609464',
  '191291609504',
  '191291609744',
  '191291609944',
  '191291609984',
  '191291610184',
  '191291610224',
  '191291610384',
  '191291610464',
  '191291610624',
  '191291610664',
  '191291610704',
  '191291610864',
  '191291610904',
  '191291610944',
  '191291611144',
  '191291611384',
  '191291611424',
  '191291611584',
  '191291611624',
  '191291611824',
  '191291611864',
  '191291612064',
  '191291612104',
  '191291612144',
  '191291612304',
  '191291612384',
  '191291612544',
  '191291612624',
  '191291612784',
  '191291612824',
  '191291612864',
  '191291613064',
  '191291613104',
  '191291613264',
  '191291613304',
  '191291613504',
  '191291613744',
  '191291613784',
  '191291613824',
  '191291613984',
  '191291614024',
  '191291614264',
  '191291614304',
  '191291614544',
  '191291614704',
  '191291614744',
  '191291614784',
  '191291614944',
  '191291615024',
  '191291615184',
  '191291615224',
  '191291615264',
  '191291615464',
  '191291615504',
  '191291615664',
  '191291615704',
  '191291615744',
  '191291615904',
  '191291615944',
  '191291615984',
  '191291616144',
  '191291616184',
  '191291616384',
  '191291616464',
  '191291616704',
  '191291616904',
  '191291616944',
  '191291617144',
  '191291617344',
  '191291617424',
  '191291617624',
  '191291617824',
  '191291617864',
  '191291618064',
  '191291618104',
  '191291618304',
  '191291618344',
  '191291618544',
  '191291618584',
  '191291618784',
  '191291618864',
  '191291619024',
  '191291619064',
  '191291619104',
  '191291619304',
  '191291619344',
  '191291619584',
  '191291619784',
  '191291619824',
  '191291619984',
  '191372074054',
  '191427934514',
  '191546374999',
  '191582612520',
  '191678990604',
  '191754438929',
  '191976328284',
  '192128603683',
  '192236338558',
  '192568548124',
  '193009624510',
  '193015525839',
  '193047956846',
  '193085860479',
  '193276506922',
  '193276507082',
  '193282394143',
  '193371369589',
  '193371369789',
  '193371369829',
  '193371369989',
  '193371370029',
  '193371370069',
  '193371370229',
  '193371370309',
  '193371370469',
  '193371370509',
  '193371370549',
  '193371370709',
  '193371370749',
  '193371370789',
  '193371370949',
  '193371370989',
  '193371371029',
  '193380479225',
  '194116316854',
  '194203702295',
  '194317648536',
  '194939104927',
  '195074644510',
  '195079443811',
  '195079443971',
  '195185193722',
  '196552341260',
  '196744501910',
  '196978256527',
  '197121052464',
  '198185447468',
  '198945056127',
  '200285140488',
  '201840918868',
])
